let appStore = null;

export const registerAppStore = (store) => {
  appStore = store || null;
};

export const getAppStore = () => appStore;
